/* ONH PDP V14 — position ALL existing product label overlays against the
   rendered photograph (never against the wider gallery column).
   This helper changes geometry only: it does not create/remove an overlay,
   inspect or modify tags, touch pricing, or alter click/zoom navigation. */
(function () {
  'use strict';

  function init() {
    var root = document.querySelector('#productinfo.onh-pdp-v2 #product-left');
    if (!root) return;

    var scheduled = false;
    var observed = typeof WeakSet === 'function' ? new WeakSet() : null;
    var resizeObserver = typeof ResizeObserver !== 'undefined'
      ? new ResizeObserver(requestMeasure) : null;

    function requestMeasure() {
      if (scheduled) return;
      scheduled = true;
      window.requestAnimationFrame(function () {
        scheduled = false;
        measure();
      });
    }

    function getImage(host) {
      // The live gallery replaces its anchor/image on every thumbnail or
      // variant change; the single-image branch uses an ordinary anchor.
      return host.querySelector('.rg-image > a > img:not(.prod-img-overlay), ' +
        '.rg-image > img:not(.prod-img-overlay), ' +
        ':scope > a > img:not(.prod-img-overlay), ' +
        ':scope > img:not(.prod-img-overlay), ' +
        '.rg-image > model-viewer');
    }

    function measure() {
      var hosts = root.querySelectorAll('#rg-gallery-main > .rg-image-wrapper, .singleimage');
      for (var i = 0; i < hosts.length; i++) {
        var host = hosts[i];
        var overlays = host.querySelectorAll(':scope > img.prod-img-overlay');
        if (!overlays.length) continue;
        var photo = getImage(host);
        if (!photo || !photo.isConnected) continue;
        if (photo.tagName === 'IMG' && (!photo.complete || !photo.naturalWidth)) continue;

        var imageBox = photo.getBoundingClientRect();
        var hostBox = host.getBoundingClientRect();
        if (imageBox.width <= 0 || imageBox.height <= 0 || hostBox.width <= 0) continue;

        // Geometry values are relative to the image wrapper. Absolute overlays
        // therefore follow centered landscape, portrait and square images.
        var css = window.getComputedStyle(host);
        var borderLeft = parseFloat(css.borderLeftWidth) || 0;
        var borderTop = parseFloat(css.borderTopWidth) || 0;
        var left = imageBox.left - hostBox.left - borderLeft + host.scrollLeft;
        var top = imageBox.top - hostBox.top - borderTop + host.scrollTop;
        // V15.14: One corner treatment for every status ribbon. The artwork's
        // top-left origin remains flush with the photograph; growing it about
        // 20% moves the diagonal label's midpoint ~20px inward on a typical
        // desktop hero, without translating it away from that corner.
        var mobile = window.matchMedia('(max-width: 768px)').matches;
        var maxWidth = mobile ? 120 : 240;
        var scale = mobile ? 0.48 : 0.36;
        // Ribbons are 537 x 495. Keep the entire ribbon over very shallow
        // landscape photographs instead of letting it hang off the photo.
        var ribbonAspect = 495 / 537;
        var ribbonWidth = Math.min(maxWidth, imageBox.width * scale,
          imageBox.height * 0.98 / ribbonAspect);
        host.style.setProperty('--onh-photo-overlay-x', Math.max(0, left).toFixed(2) + 'px');
        host.style.setProperty('--onh-photo-overlay-y', Math.max(0, top).toFixed(2) + 'px');
        host.style.setProperty('--onh-photo-overlay-width', ribbonWidth.toFixed(2) + 'px');
      }
    }

    function observeImages() {
      if (!resizeObserver) return;
      var hosts = root.querySelectorAll('#rg-gallery-main > .rg-image-wrapper, .singleimage');
      for (var i = 0; i < hosts.length; i++) {
        var host = hosts[i];
        var photo = getImage(host);
        if (!observed.has(host)) {
          resizeObserver.observe(host);
          observed.add(host);
        }
        if (photo && !observed.has(photo)) {
          resizeObserver.observe(photo);
          observed.add(photo);
        }
      }
    }

    // Existing gallery script regenerates the image anchor; observe only DOM
    // children (not attributes/styles), avoiding recursive geometry updates.
    if (typeof MutationObserver !== 'undefined') {
      var mutationObserver = new MutationObserver(function () {
        observeImages();
        requestMeasure();
      });
      mutationObserver.observe(root, { childList: true, subtree: true });
    }
    // Image loads are captured even when they occur after gallery initialization.
    root.addEventListener('load', function (ev) {
      if (ev.target && ev.target.tagName === 'IMG') requestMeasure();
    }, true);
    window.addEventListener('resize', requestMeasure, { passive: true });
    observeImages();
    requestMeasure();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
